import styled from '@emotion/styled';
import { List as MuiList, Paper, Typography } from '@material-ui/core';
import { createElement, FC, Fragment, MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';

import { ProjectTypeForListFragment } from '../../../../generated/graphql';
import { SPACING_LARGE, SPACING_REGULAR } from '../../../constant/spacing';
import _DummyItem from './DummyItem';
import Item from './Item';

type Props = {
  projectTypes: Array<ProjectTypeForListFragment>;
  basicProjectTypeKey: string[];
  onSelect: (e: MouseEvent<HTMLElement>, projectType: ProjectTypeForListFragment) => void;
  loading: boolean;
  className?: string;
};

const ProjectTypesList: FC<Props> = ({ className, projectTypes, basicProjectTypeKey, onSelect, loading }: Props) => {
  // 広告用のBasic Project Type を除外する
  const filteredProjectTypes = projectTypes.filter((projectType) => !basicProjectTypeKey.includes(projectType.key));

  if (loading) {
    return (
      <div className={className}>
        <Heading variant="h5">
          <FormattedMessage id="project_types_list_page.heading" />
        </Heading>
        <MuiList>
          {new Array(5).fill(null).map((_, i) => (
            <Fragment key={`dummy_${i}`}>
              <DummyItem />
            </Fragment>
          ))}
        </MuiList>
      </div>
    );
  }

  return (
    <div className={className}>
      <Heading variant="h5">
        <FormattedMessage id="project_types_list_page.heading" />
      </Heading>
      <MuiList>
        {filteredProjectTypes.map((projectType, index: number) => (
          <Fragment key={index}>
            <ItemWrapper>
              <Item projectType={projectType} onSelect={onSelect} />
            </ItemWrapper>
          </Fragment>
        ))}
      </MuiList>
    </div>
  );
};

const Heading = styled(Typography)`
  margin-bottom: ${SPACING_LARGE}px;
`;

const ItemWrapper = styled(Paper)`
  margin-top: ${SPACING_REGULAR}px;

  &:first-of-type {
    margin-top: 0;
  }
`;

const DummyItem = styled(_DummyItem)`
  margin-top: ${SPACING_REGULAR}px;
  padding: ${SPACING_REGULAR}px;

  &:first-of-type {
    margin-top: 0;
  }
`;

export default ProjectTypesList;
